import React from "react"

import { Field, Form, Formik } from "formik"
import * as Yup from "yup"

import { RunMutation } from "src/types"

import { gql, useMutation } from "hooks/urql"

import { ErrorMessage, SubmitButton } from "components/Forms/Formik"
import ModalWithProvidedBody from "components/ModalWithProvidedBody"

import lessonTopicsFragment from "./lessonTopicsFragment"

const ValidationSchema = Yup.object().shape({
  name: Yup.string().required("Please specify a name"),
})

const NewLessonPlanButton = ({ lessonPlanId }) => {
  const [, runMutation] = useMutation(createLessonTopicMutation) as [
    any,
    RunMutation
  ]

  const formState = {
    name: "",
  }

  const handleSubmit = (values, actions, closeModal) => {
    actions.setStatus(undefined)
    runMutation({ name: values.name, lessonPlanId }).then(result => {
      if (result.error) {
        actions.setSubmitting(false)
        actions.setStatus(
          result.error.message ||
            "An error occurred while creating your chapter"
        )
        return
      }
      closeModal()
    })
  }

  return (
    <ModalWithProvidedBody
      buttonClassName="btn btn-success"
      buttonText="New Chapter"
      modalClassName="bootstrap-modal"
      modalTitle="New Chapter"
    >
      {({ closeModal }) => (
        <Formik
          initialValues={formState}
          onSubmit={(values, actions) =>
            handleSubmit(values, actions, closeModal)
          }
          validationSchema={ValidationSchema}
        >
          {({ status, isSubmitting }) => (
            <Form>
              <div className="modal-body">
                <div className="form-group">
                  <label className="form-label w-100">
                    Name
                    <Field className="form-control" name="name" autoFocus />
                    <ErrorMessage name="name" />
                  </label>
                </div>
              </div>
              <div className="modal-footer">
                {status && (
                  <div className="alert alert-danger mt-4">{status}</div>
                )}
                <SubmitButton isSubmitting={isSubmitting} text="Create" />
              </div>
            </Form>
          )}
        </Formik>
      )}
    </ModalWithProvidedBody>
  )
}

const createLessonTopicMutation = gql`
  ${lessonTopicsFragment}
  mutation CreateLessonTopicMutation($lessonPlanId: ID!, $name: String!) {
    createLessonTopic(name: $name, lessonPlanId: $lessonPlanId) {
      lessonPlan {
        lessonTopics {
          ...LessonTopicsFields
        }
      }
    }
  }
`

export default NewLessonPlanButton
